import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebsiteSchemaContainerModel } from '../../../../../models/aggregates/website-schema';
import { ApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class WebsiteSchemaService extends BaseApiTemplateService<WebsiteSchemaContainerModel> {
  
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-schemas';

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-schemas';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-schemas';
  }

  getDefaultSchema(schemaType: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.apiUrl + '/schema/' + schemaType;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/schema/' + schemaType;
    }
    return this.httpClient.get<ApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }
}


